import { render, staticRenderFns } from "./AlertsIndex.vue?vue&type=template&id=38c9986b&scoped=true&"
import script from "./AlertsIndex.vue?vue&type=script&lang=js&"
export * from "./AlertsIndex.vue?vue&type=script&lang=js&"
import style0 from "./AlertsIndex.vue?vue&type=style&index=0&id=38c9986b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c9986b",
  null
  
)

export default component.exports